var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNigeria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.001C24.8366 32.001 32 24.8375 32 16.001C32 7.16442 24.8366 0.000976562 16 0.000976562C7.16344 0.000976562 0 7.16442 0 16.001C0 24.8375 7.16344 32.001 16 32.001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0009C0 22.8804 4.342 28.745 10.4348 31.0058V0.996155C4.342 3.25678 0 9.12153 0 16.0009V16.0009Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0009C32 9.12153 27.658 3.25678 21.5652 0.996155V31.0058C27.658 28.745 32 22.8804 32 16.0009V16.0009Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigeria);
export default __webpack_public_path__ + "static/media/nigeria.d3fdfb02.svg";
export { ForwardRef as ReactComponent };